module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "category__item"
  }, [_c('div', {
    staticClass: "weui-flex",
    on: {
      "click": _vm.showList
    }
  }, [_c('p', {
    staticClass: "weui-flex__item"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.img) ? _c('img', {
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('div', {
    staticClass: "vw-category-icon"
  }, [_c('i', {
    class: _vm.icon,
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "toggle"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.onShow),
      expression: "onShow"
    }],
    staticClass: "category-content"
  }, [_vm._t("default")], true)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-ebc49af8!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/category/category.vue
// module id = 290
// module chunks = 0